<!--
 * @Author: 张天昊
 * @Date: 2024-11-13 10:53:53
 * @LastEditTime: 2024-11-15 14:46:24
 * @LastEditors: 张天昊
 * @Description: 
 * @FilePath: /Mobile/src/pages/index/privacyCollectDetail.vue
-->
<template>
  <div class="container agrement-container">
    <div class="title">数据说明：统计数字部分为非实时更新，可能存在延时</div>
    <div v-for="(item, i) in infoData.fields" :key="i">
      <privacy-detail-content :index="i" :fieldData="item">
      </privacy-detail-content>
    </div>
  </div>
</template>

<script>
import PrivacyDetailContent from './components/PrivacyDetailContent.vue';
import { mapState } from 'vuex';

export default {
  name: 'PrivacyCollectDetail',

  components: {
    PrivacyDetailContent
  },
  data() {
    return {
      pageTitle: '',
      keyName: '',
      infoData: {}
    };
  },
  mounted() {
    let _this = this;
    _this.keyName = _this.$route.query.keyName;
    for (let index = 0; index < this.infoListData.length; index++) {
      const element = this.infoListData[index];
      if (element.key === this.keyName) {
        this.infoData = element;
        break;
      }
    }
    this.setAppTitle(_this.infoData.name);
  },

  methods: {
    setAppTitle: function (title) {
      try {
        window.yyn.app.invoke('setTitle', title);
      } catch (e) {
        console.log('设置app标题错误，' + e.message);
      }
    }
  },

  computed: {
    ...mapState('privacy', ['infoListData'])
  }
};
</script>
<style lang="less" scoped>
.agrement-container {
  padding: 16px 24px;
  font-size: 14px;
  line-height: 22px;
  color: #333;
  font-family: PingFang SC, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.title {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #999999;
}
</style>
